import { Box, makeStyles, Typography } from "@material-ui/core";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import { FC, useEffect, useRef, useState } from "react";

dayjs.extend(relativeTime);

const useStyles = makeStyles((theme) => ({
  time: {
    fontSize: 10,
    color: theme.palette.grey[500],
    lineHeight: 3,
  },
}));

const TimeFromNow: FC<TimeFromNowProps> = ({ createdAt }) => {
  const classes = useStyles({});
  const [date, setDate] = useState(dayjs(createdAt).fromNow());
  const intervalRef = useRef<any>(null);

  useEffect(() => {
    intervalRef.current = setInterval(() => {
      setDate(dayjs(createdAt).fromNow());
    }, 30 * 1000);

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    };
  }, [createdAt]);

  return (
    <Box mx={1}>
      <Typography className={classes.time}>{date}</Typography>
    </Box>
  );
};

interface TimeFromNowProps {
  createdAt: Date;
}

export default TimeFromNow;
